import { CommissionByMovementReportType } from '@/core/domain/questReport/Reports/CommssionByMovement/CommissionByMovement.types';
import { Checkbox, Col, Form, Row } from 'antd';
import { useIntl } from 'react-intl';

const ByMovimentsCheckBoxs = ({
  isPaintedType,
}: {
  isPaintedType: boolean;
}) => {
  const intl = useIntl();

  return (
    <Row>
      {!isPaintedType && (
        <>
          <Col xs={4.8}>
            <Form.Item
              name="parts"
              noStyle
              valuePropName="checked"
              initialValue={true}
            >
              <Checkbox>
                {intl.formatMessage({
                  id: 'byMovimentsForm.form.situation.checkbox.parts',
                })}
              </Checkbox>
            </Form.Item>
          </Col>

          <Col xs={4.8}>
            <Form.Item
              name="providedParts"
              noStyle
              valuePropName="checked"
              initialValue={false}
            >
              <Checkbox>
                {intl.formatMessage({
                  id: 'byMovimentsForm.form.situation.checkbox.suppliedParts',
                })}
              </Checkbox>
            </Form.Item>
          </Col>
        </>
      )}

      <Col xs={4.8}>
        <Form.Item
          name="services"
          noStyle
          valuePropName="checked"
          initialValue={true}
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'byMovimentsForm.form.situation.checkbox.services',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      <Col xs={4.8}>
        <Form.Item
          name="outsource"
          noStyle
          valuePropName="checked"
          initialValue={true}
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'byMovimentsForm.form.situation.checkbox.the3rd',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      {!isPaintedType && (
        <Col xs={4.8}>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const reportType = getFieldValue('reportType');

              return (
                <Form.Item
                  name="directSale"
                  noStyle
                  valuePropName="checked"
                  initialValue={true}
                >
                  <Checkbox
                    disabled={
                      reportType !==
                      CommissionByMovementReportType.estimatorSeller
                    }
                  >
                    {intl.formatMessage({
                      id: 'byMovimentsForm.form.situation.checkbox.directSale',
                    })}
                  </Checkbox>
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};

export default ByMovimentsCheckBoxs;
